module.exports = __webpack_public_path__ + "media/images/icons/country_flags/th-d3dea0cee87c83e3a1e65baf0081b1e3.svg";